// D108.4: importing a vendor bill onto a line adds the bill's supplier to the line's vendor
// rows. A nameless row (the one a build seeds for the rest after a stock draw, or a quantity
// typed before the supplier) IS the place for it: filled, not paralleled, or the same goods
// are billed twice (stock + the rest + the bill's quantity again).
export type VendorRow = { vendorName: string; vendorId?: string | null; quantity: number };

export function addBillVendorRow(
  rows: VendorRow[] | undefined,
  bill: { supplierName: string; supplierVendorId: string | null; quantity: number }
): VendorRow[] {
  const list = Array.isArray(rows) ? [...rows] : [];
  if (bill.supplierVendorId && list.some((v) => String(v?.vendorId || '') === bill.supplierVendorId)) return list;
  const nameless = list.findIndex((v) => !String(v?.vendorName || '').trim() && !v?.vendorId);
  if (nameless >= 0) {
    const row = list[nameless];
    list[nameless] = {
      ...row,
      vendorName: bill.supplierName,
      vendorId: bill.supplierVendorId,
      quantity: row.quantity > 0 ? row.quantity : bill.quantity,
    };
    return list;
  }
  list.push({ vendorName: bill.supplierName, vendorId: bill.supplierVendorId, quantity: bill.quantity });
  return list;
}
